module.exports = __webpack_public_path__ + "index_pc/img/icon_zone.ff6cd354.png";